export const maxNumberOfTags = 10;
export const maxNumberOfCategories = 3;
export const platformFee = 0.05; // 5%
export const maxCommentCharacter = 500;
export const maxSizeImagesUpload = 50000000; //50MB
export const maxSizeAssetsUpload = 50000000; //50MB
export const minTextLength = 10;
export const deliveryTime = [
  "Dưới 1 tuần",
  "Trong khoảng 1-2 tuần",
  "Trong khoảng 1 tháng",
  "Trong khoảng 2 tháng",
  "Trong khoảng 3 tháng",
];
export const sortOptions = [
  { name: "Đề xuất", code: "" },
  { name: "Mới nhất", code: "createdOn" },
  { name: "Xem nhiều nhất", code: "viewCount" },
  { name: "Thích nhiều nhất", code: "likeCount" },
];
